export default __webpack_public_path__ + "static/project-slide-2-2016-765-b3a4d4ae788462e6c7e95806800a0109.webp";